<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-body>
                <form class="kt-form" @submit.prevent="submit($event)" id="submit-form" v-if="status==='success'">
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="title">
                                        {{ $t('label.title') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        id="title"
                                        name="title"
                                        v-model="questionForm.title"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                        <kt-form-row>
                            <kt-col lg="12" md="12" sm="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{$t('label.question')}}
                                    </kt-form-label>
                                    <ckeditor :editor="editor"
                                              v-model="questionForm.question"
                                              :config="editorConfig"
                                              tag-name="textarea"
                                    >
                                    </ckeditor>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="12" md="12" sm="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{$t('label.answer')}}
                                    </kt-form-label>
                                    <ckeditor :editor="editor"
                                              v-model="questionForm.answer"
                                              :config="editorConfig"
                                              tag-name="textarea"
                                    >
                                    </ckeditor>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>
                    <kt-form-action>
                        <button
                            class="btn btn-success btn-wide"
                            type="submit"
                            id="submit-btn"
                        >
                            {{ $t('btn.submit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from "vuex";
import { KTApp } from "@/plugins/core/app"
import $ from 'jquery'
import questionForm from './components/question-form'
import { i18n } from '@/plugins/i18n'
import {knowledgeManagementService} from "../../common/api.service";
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import {editorConfig} from '@/constants/ckeditorConfigs'

export default {
    components: {
        mainContent,
        ckeditor: CKEditor.component
        // questionForm
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('KnowledgeManagement/createQuestionForm')
        })
    },
    data() {
        return {
            data: null,
            editor: ClassicEditor,
            editorData: '',
            editorConfig: editorConfig,
            questionForm: {}
        }
    },
    computed: {
        ...mapGetters('KnowledgeManagement', [
            'status'
        ])
    },
    methods: {
        submit(e) {
            let form = $(e.target)
            let btn = $('#submit-btn')

            KTApp.progress(btn)

            let params = {
                title: this.questionForm.title,
                question: this.questionForm.question,
                answer: this.questionForm.answer,
                cat_id: this.$route.params.hashid
            }

            knowledgeManagementService.createQuestion(params)
                .then(response => {
                    this.$router.push('/knowledge-categories/' + this.$route.params.hashid + '/details#questions')
                })
                .catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        }
    }
}
</script>

<style >

</style>